module.exports = __webpack_public_path__ + "media/img/avatar-d9585c8b.png";